import { useNavigate } from 'react-router-dom';

import { Button, Text } from 'shared/components/ui';
import { ProfileSubheader } from 'features/profile';
import { useGetUserSubscriptionQuery, useCreateBillingPortalSessionMutation } from 'services';
import { currencyFormatter, NUMBERS_FORMAT, formatDate, PROGAI_EMAIL } from 'shared/utils';
import { BillingPlan } from 'shared/models';
import { ProfileSubscriptionSkeleton } from 'features/profile';

import styles from './index.module.scss';

export const ProfileSubscription = () => {
	const navigate = useNavigate();
	const { data, isLoading } = useGetUserSubscriptionQuery();
	const [createPortalSession] = useCreateBillingPortalSessionMutation();

	const handleUpgrade = () => {
		navigate('/registration/plan');
	};

	const handleCancelSubscription = async () => {
		try {
			const portalUrl = await createPortalSession({
				return_url: window.location.href
			}).unwrap();
			window.location.href = portalUrl;
		} catch (error) {
			console.error('Failed to open billing portal:', error);
		}
	};

	return (
		<section>
			<ProfileSubheader>
				<Text variant="inter/16/bold" component="h3">
					Subscription
				</Text>
				{data && data.billing_plan === BillingPlan.FREE && (
					<Button type="primary" onClick={handleUpgrade}>
						Upgrade
					</Button>
				)}
			</ProfileSubheader>
			<main className={styles.content}>
				<div className={styles.plan}>
					<Text variant="inter/14/medium" className={styles.planLeft}>
						Your current plan
					</Text>
					<div className={styles.planRight}>
						<div className={styles.planInfo}>
							{isLoading && <ProfileSubscriptionSkeleton />}
							{data && (
								<>
									<Text component="h4" variant="grotesk/20/bold" className={styles.planTitle}>
										{data.billing_plan === BillingPlan.FREE ? 'Free Trial' : data.billing_plan}
									</Text>
									<div className={styles.planRow}>
										<div className={styles.planDetails}>
											<Text
												component="p"
												variant="inter/16/regular"
												color="grey"
												className={styles.planPrice}>
												<Text variant="inter/16/bold" color="black">
													{currencyFormatter.format(data.amount_paid / 100)}
												</Text>{' '}
												/{' '}
												{data.billing_plan === BillingPlan.FREE
													? '14 days'
													: `a ${data.interval}`}
											</Text>
											<Text component="p" color="grey">
												{data.billing_plan === BillingPlan.FREE
													? 'Your subscription expires'
													: data.cancel_at_period_end
													? 'Your subscription ends'
													: 'Your next bill is'}{' '}
												on {formatDate(data.expiration_date, NUMBERS_FORMAT)}
											</Text>
										</div>
										{data.billing_plan !== BillingPlan.FREE && data.subscription_id && (
											<Button type="primary" onClick={handleCancelSubscription}>
												{data.cancel_at_period_end
													? 'Resume Subscription'
													: 'Cancel Subscription'}
											</Button>
										)}
									</div>
								</>
							)}
						</div>
						{data && data.billing_plan !== BillingPlan.FREE && (
							<Text component="p" variant="inter/14/medium" className={styles.helpText}>
								{data.subscription_id
									? 'If you want to upgrade or add credits'
									: 'If you want to upgrade, add credits or cancel subscription'}{' '}
								<a href={`mailto:${PROGAI_EMAIL}`} className={styles.contact}>
									contact us
								</a>
							</Text>
						)}
					</div>
				</div>
			</main>
		</section>
	);
};
